const IsEqualIgnoreCase = (item, otherItem) => {
  if (!item) return false;
  if (!otherItem) return false;

  return item.toUpperCase() == otherItem.toUpperCase();
};

export default IsEqualIgnoreCase;
